import React from "react";

function Footer() {
  return (
    <footer className="mt-10 border-t border-slate-700/40 pt-6 pb-4 text-center">
      
      {/* Top line */}
      <div className="text-sm text-slate-400 tracking-wide">
        Built with precision for smarter money tracking
      </div>

      {/* Brand / Name */}
      <div className="mt-2 text-[#f5a623] font-semibold tracking-wide">
        Expense Analyzer
      </div>

      {/* Bottom row */}
      <div className="mt-3 text-xs text-slate-500 flex justify-center items-center gap-2 flex-wrap">
        
        <span>All rights reserved</span>
      </div>

    </footer>
  );
}

export default Footer;